import React, { useState, useEffect } from 'react'

import { XIcon } from '@heroicons/react/outline'
import Select from 'react-select'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import RecipesForm from '../RecipesForm/RecipesForm';
import 'react-tabs/style/react-tabs.css';
import { UNIT_OPTIONS, gramsFor, gramsForItem } from '../../../services/Units';
import GroceriesService from '../../../services/GroceriesService';
import {
    getDislikedNames, getDislikedLabels, filterOptions,
    getAllergenNames, getAllergenLabels, removeAllergenGroceries,
    getAllergenIngredients, recipeHasAllergen
} from '../../../services/DislikedFood';

const PlansForm = ({ planDescription, setPlanDescription, planRecipeItems, setPlanRecipeItems, planCalories, setPlanCalories, ingredientsData, groceriesData, setIsOpen, options, selectedClient, usedRecipes }) => {

    // Namirnice koje klijent ne voli se ne nude, kao ni recepti koji ih sadrze.
    // Checkbox ispod omogucava da se ipak prikazu, kad je to potrebno.
    const [allowDisliked, setAllowDisliked] = useState(false);
    const dislikedNames = getDislikedNames(selectedClient);
    const dislikedLabels = getDislikedLabels(selectedClient);
    const afterDisliked = allowDisliked ? options : filterOptions(options, dislikedNames);
    const hiddenCount = Array.isArray(options) ? options.length - afterDisliked.length : 0;

    // Alergije i intolerancije - strože pravilo.
    // Namirnica koja je alergen se uopšte ne nudi; recept koji je sadrži
    // ostaje u ponudi, ali je označen upozorenjem.
    const allergenNames = getAllergenNames(selectedClient);
    const allergenLabels = getAllergenLabels(selectedClient);
    const availableOptions = removeAllergenGroceries(afterDisliked, allergenNames);
    const blockedByAllergen = afterDisliked.length - availableOptions.length;

    // Kako se stavka ispisuje u padajućem meniju (upozorenje se ne upisuje u plan)
    const renderOption = (option) => {
        const usedIn = usedRecipes && (usedRecipes[option.value] || usedRecipes[option.label]);
        const hasAllergen = recipeHasAllergen(option, allergenNames);
        if (!hasAllergen && !usedIn) return option.label;
        return (
            <span className="flex items-center">
                {hasAllergen && <span className="mr-1 text-red-600">&#9888;</span>}
                <span>{option.label}</span>
                {usedIn &&
                    <span className="ml-2 text-[11px] text-amber-600">(već u Jelovniku {usedIn})</span>}
            </span>
        );
    };

    const [description, setDescription] = useState(planDescription || '');
    const [userData, setUserData] = useState({});
    const [recipeData, setRecipeData] = useState({});
    const [meal, setMeal] = useState(planRecipeItems || {});
    // Slobodna napomena za ovaj obrok (npr. "dupla kolicina - dorucak sutra je isti").
    // Vidi se u aplikaciji i u PDF-u.
    const [mealNote, setMealNote] = useState((planRecipeItems && planRecipeItems.note) || '');
    const [recipes, setRecipes] = useState(planRecipeItems.recipes || []);

    // Izabrani recepti koji sadrže alergen - za svaki spisak sastojaka za zamenu
    const selectedWithAllergen = (Array.isArray(recipes) ? recipes : [])
        .map((r) => ({
            name: (r && (r.name || r.label)) || 'Recept',
            ingredients: getAllergenIngredients(r, allergenNames),
        }))
        .filter((r) => r.ingredients.length > 0);

    const [groceries, setGroceries] = useState(planRecipeItems.groceries || []);
    const [advancedGroceries, setAdvancedGroceries] = useState(planRecipeItems.recipes ? (planRecipeItems.recipes[0] ? planRecipeItems.recipes[0].recipeItems : []) : [] || []);
    const [advancedRecipe, setAdvancedRecipe] = useState([]);
    const [mealCalories, setMealCalories] = useState(0);
    const [mealCarbs, setMealCarbs] = useState(0);
    const [mealFats, setMealFats] = useState(0);
    const [mealProteins, setMealProteins] = useState(0);

    const [advancedMealCalories, setAdvancedMealCalories] = useState(0);
    const [advancedMealCarbs, setAdvancedMealCarbs] = useState(0);
    const [advancedMealFats, setAdvancedMealFats] = useState(0);
    const [advancedMealProteins, setAdvancedMealProteins] = useState(0);

    const [name, setName] = useState('');
    const [recipeItems, setRecipeItems] = useState(ingredientsData || []);
    const [id, setId] = useState(null);


    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (planRecipeItems && (planRecipeItems.recipes || planRecipeItems.groceries)) {
            if(isAdvanced(planRecipeItems)) {
                mapAdvancedMealItems(planRecipeItems)
            } else {
                mapMealItems(planRecipeItems)
            }
            
        }
    }, [])
    
    const isAdvanced = (plan) => {
        let advanced = false;
        if(plan.recipes) {
            plan.recipes.forEach(item => {
                if (item.isAdvanced) {
                    setName(item.name)
                    advanced = true;
                } 
            })
        }
        return advanced;
    }

    const handleEditMeasure = (value, ingredient, key) => {
        let items = meal;

        items.groceries = items.groceries.map((item, index) => {
            if (item === ingredient && index === key) {
                item.servingSize = Number(value);
            }
            return item;
        });

        items.recipes = items.recipes.map((item, index) => {
            if (item === ingredient && index === key) {
                item.servingSize = Number(value);
            }
            return item;
        });
        setMeal(items);
        setGroceries(items.groceries)
        setRecipes(items.recipes)
        mapMealItems(items, true)
    }

    const handleAdvancedEditMeasure = (value, ingredient, key) => {
        let ag = []
        advancedGroceries.forEach(grocery => ag.push({...grocery}))
        setAdvancedGroceries(ag)

        ag = ag.map((item, index) => {
            if (item.value === ingredient.value && index === key) {
                item.servingSize = Number(value);
            }
            return item;
        });

        let tempMeal = { recipes: [], groceries: ag }
        setAdvancedGroceries(ag)
        mapAdvancedMealItems(tempMeal)
    }

    const handleEditUnit = (value, ingredient, key) => {
        let items = meal;
        items.groceries = items.groceries.map((item, index) => {
            if (item === ingredient && index === key) { item.unit = value; if (value === 'kom' && item.pieceWeight == null && item.ingredient && item.ingredient.pieceWeight) item.pieceWeight = item.ingredient.pieceWeight; }
            return item;
        });
        setMeal(items);
        setGroceries([...items.groceries])
        mapMealItems(items, true)
    }

    const handleAdvancedEditUnit = (value, ingredient, key) => {
        let ag = []
        advancedGroceries.forEach(grocery => ag.push({ ...grocery }))
        ag = ag.map((item, index) => {
            if (item.value === ingredient.value && index === key) { item.unit = value; if (value === 'kom' && item.pieceWeight == null && item.ingredient && item.ingredient.pieceWeight) item.pieceWeight = item.ingredient.pieceWeight; }
            return item;
        });
        setAdvancedGroceries(ag)
        mapAdvancedMealItems({ recipes: [], groceries: ag })
    }

    const persistPieceWeight = (item) => {
        const ing = item.ingredient;
        if (ing && ing.id && Number(item.pieceWeight) > 0) {
            ing.pieceWeight = Number(item.pieceWeight);
            const updated = {
                id: ing.id, name: ing.name, calories: ing.calories,
                carbohydrates: ing.carbohydrates, proteins: ing.proteins,
                fats: ing.fats, category: ing.category, defaultSize: ing.defaultSize || 100,
                pieceWeight: Number(item.pieceWeight)
            };
            GroceriesService.updateGrocery(updated).catch(() => { });
        }
    }

    const handleEditPieceWeight = (value, ingredient, key) => {
        let items = meal;
        items.groceries = items.groceries.map((item, index) => {
            if (item === ingredient && index === key) { item.pieceWeight = value === '' ? null : Number(value); }
            return item;
        });
        setMeal(items);
        setGroceries([...items.groceries])
        mapMealItems(items, true)
    }

    const handleAdvancedEditPieceWeight = (value, ingredient, key) => {
        let ag = []
        advancedGroceries.forEach(grocery => ag.push({ ...grocery }))
        ag = ag.map((item, index) => {
            if (item.value === ingredient.value && index === key) { item.pieceWeight = value === '' ? null : Number(value); }
            return item;
        });
        setAdvancedGroceries(ag)
        mapAdvancedMealItems({ recipes: [], groceries: ag })
    }

    const handleDeleteIngredient = (ingredient) => {
        let items = { ...meal };
        items.groceries = items.groceries.filter(item => item !== ingredient);
        items.recipes = items.recipes.filter(item => item !== ingredient);
        setGroceries(items.groceries)
        setRecipes(items.recipes)
        mapMealItems(items)
        return setMeal(items);
    }

    const handleAdvancedDeleteIngredient = (ingredient) => {
        let items = [...advancedGroceries]
        items = items.filter(item => item !== ingredient);
        let tempMeal = { recipes: [], groceries: items }
        setAdvancedGroceries(items)
        mapAdvancedMealItems(tempMeal)
    }


    const mapMealItems = (meal, shouldRecalculate) => {
        let calories = 0;
        let carbs = 0;
        let proteins = 0;
        let fats = 0;

        if (meal.calories && meal.carbs && meal.proteins && meal.fats && !shouldRecalculate) {
            calories += Number(meal.calories);
            carbs += Number(meal.carbs);
            proteins += Number(meal.proteins);
            fats += Number(meal.fats);
        } else {
            meal.groceries.forEach(item => {
                calories += Number(item.ingredient.calories) * (gramsForItem(item) / 100);
                carbs += Number(item.ingredient.carbohydrates) * (gramsForItem(item) / 100);
                proteins += Number(item.ingredient.proteins) * (gramsForItem(item) / 100);
                fats += Number(item.ingredient.fats) * (gramsForItem(item) / 100);
            })

            meal.recipes.forEach(item => {
                if (item.servingSize && item.actualSize) {
                    calories += Number(item.calories) * (item.servingSize / item.actualSize);
                    carbs += Number(item.carbs) * (item.servingSize / item.actualSize);
                    proteins += Number(item.proteins) * (item.servingSize / item.actualSize);
                    fats += Number(item.fats) * (item.servingSize / item.actualSize);
                } else {
                    calories += Number(item.calories);
                    carbs += Number(item.carbs);
                    proteins += Number(item.proteins);
                    fats += Number(item.fats);
                }
            })
        }
        setMealCalories(Number(calories).toFixed(2))
        setMealCarbs(Number(carbs).toFixed(2))
        setMealProteins(Number(proteins).toFixed(2))
        setMealFats(Number(fats).toFixed(2))
    };

    const mapAdvancedMealItems = (meal) => {
        let calories = 0;
        let carbs = 0;
        let proteins = 0;
        let fats = 0;

        if (meal.calories && meal.carbs && meal.proteins && meal.fats) {
            calories += Number(meal.calories);
            carbs += Number(meal.carbs);
            proteins += Number(meal.proteins);
            fats += Number(meal.fats);
        } else {
            meal.groceries.forEach(item => {
                calories += Number(item.ingredient.calories) * (gramsForItem(item) / 100);
                carbs += Number(item.ingredient.carbohydrates) * (gramsForItem(item) / 100);
                proteins += Number(item.ingredient.proteins) * (gramsForItem(item) / 100);
                fats += Number(item.ingredient.fats) * (gramsForItem(item) / 100);
            })

            meal.recipes.forEach(item => {
                if (item.servingSize && item.actualSize) {
                    calories += Number(item.calories) * (item.servingSize / item.actualSize);
                    carbs += Number(item.carbs) * (item.servingSize / item.actualSize);
                    proteins += Number(item.proteins) * (item.servingSize / item.actualSize);
                    fats += Number(item.fats) * (item.servingSize / item.actualSize);
                } else {
                    calories += Number(item.calories);
                    carbs += Number(item.carbs);
                    proteins += Number(item.proteins);
                    fats += Number(item.fats);
                }
                if(item.isAdvanced) {
                    setName(item.name)
                    setDescription(item.description)
                }
            })
        }
        setAdvancedMealCalories(Number(calories).toFixed(2))
        setAdvancedMealCarbs(Number(carbs).toFixed(2))
        setAdvancedMealProteins(Number(proteins).toFixed(2))
        setAdvancedMealFats(Number(fats).toFixed(2))
    }

    const handleRecipeChange = (item) => {
        let temp = { recipes: [...recipes], groceries: [...groceries] }
        item.servingSize = item.actualSize
        let tempItem = { ...item }
        if (item.recipeItems) {
            setRecipes([...recipes, tempItem])
            if (temp.recipes) {
                temp.recipes.push(tempItem)
            } else {
                temp["recipes"] = [tempItem]
            }
        } else {
            setGroceries([...groceries, tempItem])
            if (temp.groceries) {
                temp.groceries.push(tempItem)
            } else {
                temp["groceries"] = [tempItem]
            }
        }
        mapMealItems(temp)
        return setMeal(temp);
    }

    const isNullOrWhitespace = value => {
        if (!value || value.trim() === '') {
            return true;
        }
        return false;
    }

    const handleAdvancedChangeSelection = (item) => {
        let temp = { recipes: [...recipes], groceries: [...groceries] }
        item.servingSize = item.actualSize
        let tempItem = { ...item }
        if (item.recipeItems) {
            setDescription(tempItem.description);
            setName(tempItem.name);

            let ag = [...item.recipeItems]
            let tempRecipe = { name: tempItem.name, value: tempItem.name, label: tempItem.name, description: tempItem.description, recipeItems: ag }

            tempRecipe = mapRecipeCals(tempRecipe);
            ag = [...tempRecipe.recipeItems]
            setAdvancedRecipe(tempRecipe)
            setAdvancedGroceries(ag)
        } else {
            setAdvancedGroceries([...advancedGroceries, tempItem])
            if (temp.groceries) {
                temp.groceries.push(tempItem)
            } else {
                temp["groceries"] = [tempItem]
            }
        }
        mapAdvancedMealItems(temp)
    }

    const handleFormSubmit = e => {
        if (meal.groceries) meal.groceries.forEach(item => persistPieceWeight(item));
        e.preventDefault();
        if (meal.recipes && meal.groceries && meal.recipes.length === 0 && meal.groceries.length === 0) {
            setHasError(true);

        } else {
            setIsOpen(false);
            setPlanRecipeItems({ ...meal, note: mealNote })
        }
    }

    const handleAdvancedFormSubmit = e => {
        let indexOf = indexOfRecipe(recipes, name)
        if(indexOf > -1) {
            recipes.splice(indexOf, 1)
        }
        let temp = { recipes: [...recipes], groceries: [...groceries] }
        let tempRecipe = { name: name, value: name, label: name, description: description, recipeItems: advancedGroceries }
        tempRecipe = mapRecipeCals(tempRecipe);
        tempRecipe.isAdvanced = true

        setRecipes([...recipes, tempRecipe])
        if (temp.recipes) {
            temp.recipes.push({ ...tempRecipe })
        } else {
            temp["recipes"] = [{ ...tempRecipe }]
        }
        setIsOpen(false);
        setMeal({ ...temp });
        setPlanRecipeItems({ ...temp, note: mealNote })
    }

    const indexOfRecipe = (recipes, name) => {
        let indexOf = -1;
        recipes.forEach(item => {
            if(item.name == name) {
                indexOf = recipes.indexOf(item)
            }
        })
        return indexOf;
    }

    const mapRecipeCals = (recipe) => {
        let calories = 0;
        let carbs = 0;
        let proteins = 0;
        let fats = 0;
        let actualSize = 0;
        recipe.recipeItems.forEach(item => {
            calories += Number(item.ingredient.calories) * (gramsForItem(item) / 100);
            carbs += Number(item.ingredient.carbohydrates) * (gramsForItem(item) / 100);
            proteins += Number(item.ingredient.proteins) * (gramsForItem(item) / 100);
            fats += Number(item.ingredient.fats) * (gramsForItem(item) / 100);
            actualSize += gramsForItem(item);
        })

        return {
            ...recipe,
            calories: Number(calories).toFixed(2),
            carbs: Number(carbs).toFixed(2),
            proteins: Number(proteins).toFixed(2),
            fats: Number(fats).toFixed(2),
            actualSize: Number(actualSize),
            servingSize: Number(actualSize),
        };
    }



    const mapItems = (item, key) => (
        <div className="relative flex items-center mt-3 p-2 pr-4 bg-bluePrimary bg-opacity-10 rounded" key={key}>
            <span key={key}>{item.value}</span>
            <div className='relative  ml-auto'>
                <input type="number" placeholder="Measure" value={item.servingSize} onChange={(e) => handleEditMeasure(e.target.value, item, key)} className="input-field w-20 pl-2 pr-1 placeholder:text-xs" />
                {item.recipeItems ?
                    <span className='ml-1 text-sm text-gray-800'>g</span>
                    :
                    <select value={item.unit || 'g'} onChange={(e) => handleEditUnit(e.target.value, item, key)} className='ml-1 text-xs bg-white border border-gray-300 rounded py-1.5 px-1 cursor-pointer'>
                        {UNIT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                    </select>}
                {(!item.recipeItems && item.unit === 'kom') &&
                    <input type="number" placeholder="g/kom" value={item.pieceWeight != null ? item.pieceWeight : ''} onChange={(e) => handleEditPieceWeight(e.target.value, item, key)} onBlur={() => persistPieceWeight(item)} className="input-field w-16 ml-1 pl-1 pr-1 text-xs placeholder:text-[10px]" />}
                {item.unit === 'kom' &&
                    <input type="number" placeholder="g/kom" value={item.pieceWeight != null ? item.pieceWeight : ''} onChange={(e) => handleAdvancedEditPieceWeight(e.target.value, item, key)} onBlur={() => persistPieceWeight(item)} className="input-field w-16 ml-1 pl-1 pr-1 text-xs placeholder:text-[10px]" />}
            </div>
            <span onClick={() => handleDeleteIngredient(item)} className="absolute top-0 right-0 flex items-center justify-center transform -translate-y-1/2 translate-x-1/2 w-4 h-4 border border-red-700 bg-white rounded-full  cursor-pointer">
                <XIcon className='text-red-800 w-3 h-3' />
            </span>
        </div>
    );

    const mapAdvancedItems = (item, key) => (
        <div className="relative flex items-center mt-3 p-2 pr-4 bg-bluePrimary bg-opacity-10 rounded" key={key}>
            <span key={key}>{item.value}</span>
            <div className='relative  ml-auto'>
                <input type="number" placeholder="Measure" value={item.servingSize} onChange={(e) => handleAdvancedEditMeasure(e.target.value, item, key)} className="input-field w-20 pl-2 pr-1 placeholder:text-xs" />
                <select value={item.unit || 'g'} onChange={(e) => handleAdvancedEditUnit(e.target.value, item, key)} className='ml-1 text-xs bg-white border border-gray-300 rounded py-1.5 px-1 cursor-pointer'>
                    {UNIT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
                {item.unit === 'kom' &&
                    <input type="number" placeholder="g/kom" value={item.pieceWeight != null ? item.pieceWeight : ''} onChange={(e) => handleAdvancedEditPieceWeight(e.target.value, item, key)} onBlur={() => persistPieceWeight(item)} className="input-field w-16 ml-1 pl-1 pr-1 text-xs placeholder:text-[10px]" />}
            </div>
            <span onClick={() => handleAdvancedDeleteIngredient(item)} className="absolute top-0 right-0 flex items-center justify-center transform -translate-y-1/2 translate-x-1/2 w-4 h-4 border border-red-700 bg-white rounded-full  cursor-pointer">
                <XIcon className='text-red-800 w-3 h-3' />
            </span>
        </div>
    );

    return (
        <>
            <h3 className='text-center py-2 bg-bluePrimary text-white shadow-md font-medium '>Dnevni plan</h3>
            <form className="plans-form w-full mt-6 min-h-[400px]  px-4">
                <div className="mb-4 px-3 py-2 rounded bg-amber-50 border border-amber-200">
                    <label className="font-medium text-xs text-gray-600 flex items-center">
                        <span className="mr-1">📌</span> Napomena uz obrok (npr. „dupla količina — doručak sutra je isti")
                    </label>
                    <input type="text" value={mealNote} onChange={(e) => setMealNote(e.target.value)}
                        placeholder="Kratka napomena koja se vidi u planu..."
                        className="input-field mt-1 w-full" />
                </div>

                {allergenLabels.length > 0 &&
                    <div className="mb-3 px-3 py-2 rounded bg-red-50 border border-red-200">
                        <div className="text-xs font-semibold text-red-800">
                            Alergije i intolerancije: {allergenLabels.join(', ')}
                        </div>
                        <div className="text-[11px] text-red-700 mt-0.5">
                            Ove namirnice i njihove prerađevine se ne nude
                            {blockedByAllergen > 0 && ' (sklonjeno: ' + blockedByAllergen + ')'}.
                            Recepti koji ih sadrže označeni su znakom &#9888; i mogu se koristiti
                            samo uz zamenu te namirnice.
                        </div>
                    </div>}

                {selectedWithAllergen.length > 0 &&
                    <div className="mb-4 px-3 py-2 rounded bg-red-100 border border-red-300">
                        <div className="text-xs font-semibold text-red-900 mb-1">
                            &#9888; Pažnja: izabrani recept sadrži namirnicu na koju klijent reaguje
                        </div>
                        {selectedWithAllergen.map((r, i) =>
                            <div key={i} className="text-[11px] text-red-800">
                                <span className="font-medium">{r.name}</span> — zameniti: {r.ingredients.join(', ')}
                            </div>
                        )}
                    </div>}

                {dislikedNames.length > 0 &&
                    <div className="mb-4 px-3 py-2 rounded bg-amber-50 border border-amber-200">
                        <label className="flex items-start cursor-pointer select-none">
                            <input type="checkbox" className="mt-0.5 mr-2 accent-blueSecondary cursor-pointer"
                                checked={allowDisliked} onChange={() => setAllowDisliked(!allowDisliked)} />
                            <span className="text-xs text-gray-700">
                                Prikaži i namirnice koje klijent ne voli
                                <span className="block text-[11px] text-gray-500 mt-0.5">
                                    Ne voli: {dislikedLabels.join(', ')}
                                    {!allowDisliked && hiddenCount > 0 && ' — sakriveno stavki: ' + hiddenCount}
                                </span>
                            </span>
                        </label>
                    </div>}
                <Tabs>
                    <TabList>
                        <Tab>Standardno</Tab>
                        <Tab>Napredno</Tab>
                    </TabList>

                    <TabPanel className="pt-4">
                        <div className="relative pb-6 ">
                            <label className="font-medium text-xs text-gray-500">Recepti</label>
                            <Select
                                placeholder="Pretraži..."
                                onChange={(item) => handleRecipeChange(item)}
                                formatOptionLabel={renderOption}
                                options={availableOptions}
                                classNamePrefix='select'
                            />
                            {hasError && ((meal.recipes && meal.groceries) && (meal.recipes.length === 0 || meal.groceries.length === 0)) &&
                                <span className="input-error">Unesite recept.</span>}
                        </div>
                        {recipes.map(mapItems)}
                        {groceries.map(mapItems)}

                        <p className="font-medium mt-5">Ukupno kalorija - {Number(mealCalories).toFixed(2)}</p>
                        <p className="font-medium mt-1">Ukupno proteina - {Number(mealProteins).toFixed(2)}</p>
                        <p className="font-medium mt-1">Ukupno ugljenih hidrata - {Number(mealCarbs).toFixed(2)}</p>
                        <p className="font-medium mt-1">Ukupno masti - {Number(mealFats).toFixed(2)}</p>
                        <button type="submit" className="button without-icon bg-secondaryGradient mx-auto mt-5" onClick={e => handleFormSubmit(e)}>
                            Sačuvaj
                        </button>
                    </TabPanel>
                    <TabPanel>
                        <div className="input-group">
                            <label className="font-medium text-xs text-gray-500">Naziv</label>
                            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="input-field" />
                            {hasError && isNullOrWhitespace(name) && <span className="input-error">Unesite ime recepta.</span>}
                            {hasError}
                        </div>
                        <div className="relative mt-5">
                            <label className="font-medium text-xs text-gray-500">Recepti</label>
                            <Select
                                placeholder={'Ukucajte da biste pretražili...'}
                                onChange={(item) => handleAdvancedChangeSelection(item)}
                                formatOptionLabel={renderOption}
                                options={availableOptions}
                                classNamePrefix='select'
                            />
                            {advancedGroceries.map(mapAdvancedItems)}
                            <p className="font-medium mt-5">Ukupno kalorija - {Number(advancedMealCalories).toFixed(2)}</p>
                            <p className="font-medium mt-1">Ukupno proteina - {Number(advancedMealProteins).toFixed(2)}</p>
                            <p className="font-medium mt-1">Ukupno ugljenih hidrata - {Number(advancedMealCarbs).toFixed(2)}</p>
                            <p className="font-medium mt-1">Ukupno masti - {Number(advancedMealFats).toFixed(2)}</p>
                            {hasError && (recipeItems.length === 0) &&
                                <span className="input-error">Unesite namirnicu</span>}
                        </div>

                        <div className="input-group mt-5">
                            <label className="font-medium text-xs text-gray-500">Opis</label>
                            <textarea value={description} onChange={(e) => setDescription(e.target.value)} className="input-field h-52" >
                            </textarea>
                            {hasError && isNullOrWhitespace(description) && <span className="input-error">Unesite opis recepta</span>}
                        </div>

                        <button type="submit" disabled style={{ display: "none" }} aria-hidden="true"></button>
                        <button type="submit" className="button without-icon bg-secondaryGradient mx-auto mt-5" onClick={e => handleAdvancedFormSubmit(e)}>
                            Sačuvaj
                        </button>
                    </TabPanel>
                </Tabs>

            </form>
        </>
    )
}
export default PlansForm;


